import "./events.scss";
import Banner from "../../components/banner/Banner";
import Events from "../../components/events/Events";
import RequestGeo from "../../components/requestGeo/RequestGeo";
const EventsPage = () => {
  
  return (
    <div className="events">
      <Banner title="Timeline"/>
        <Events/>
    </div>
  );
};

export default EventsPage;
